import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../Common/Navbar';
import Sidebar from '../Common/Sidebar';

function AdminLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Navbar />
      <div className="flex">
        <Sidebar role="admin" />
        <div className="flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;